import { render, staticRenderFns } from "./SocialTextFields.vue?vue&type=template&id=b2de430a"
import script from "./SocialTextFields.vue?vue&type=script&lang=js"
export * from "./SocialTextFields.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports